import React from 'react';

export type HeaderPill = {
    label: string;
    value: string | number;
};

interface CardHeaderProps {
    pills: HeaderPill[];
}

/**
 * Generic card header component with pill-style labels and values.
 * 
 * Useful for:
 * - Job cards
 * - Booking summaries
 * - Invoice cards
 * - Any card that needs labeled key-value pairs in the header
 * 
 * **Styling:** Uses `.timesheet-booking-card__header` and `.timesheet-booking-pill` classes
 * (currently defined in payroll.style.scss). When moving to common/, consider renaming to
 * `.card-header` and `.card-pill` or extracting styles to a shared stylesheet.
 */

export const CardHeader: React.FC<CardHeaderProps> = React.memo(({ pills }) => (
        <div className="timesheet-booking-card__header">
            {pills.map(pill => (
                <div className="timesheet-booking-pill" key={`${pill.label}-${pill.value}`}>
                    <span>{pill.label}</span>
                    <strong>{pill.value}</strong>
                </div>
            ))}
        </div>
    ));

CardHeader.displayName = 'CardHeader';

